import axios from "axios";
import { Route } from "vue-router";
import store from "../vuex/store";
import { AxiosRequestConfigDef } from "@/event-bus";

export class VersionCheckService {
  //interval since last check min
  INTERVAL = 14400000;
  /**
   * Checks in every set frequency the version of frontend application
   * frequency - in milliseconds, defaults to 30 minutes
   * INTERVAL - in milliseconds, do the call only if the interval is passed since last check
   */
  initVersionCheck() {
    setInterval(() => {
      const lastCheckTS = store.getters.versionCheckTimestamp;
      if (lastCheckTS) {
        const currentTS = new Date().getTime();
        if (currentTS - lastCheckTS >= this.INTERVAL) {
          store.dispatch("versionCheck");
        }
      } else {
        store.dispatch("versionCheck");
      }
    }, 1800000);
  }

  /**
   * Will do the call and check if the hash has changed or not
   */
  checkVersion() {
    const axiosInstance = axios.create(); //custom instance to avoid requiring login token
    axiosInstance.interceptors.request.use(function(config: any) {
      config.headers["Source"] = "Online";
      config.headers["Authorization"] =
        "Basic " + btoa(`teleport-frontend:${process.env.VUE_APP_VERSION_PSW}`);
      config.headers["baseUrl"] = window.location.hostname;
      return config;
    });
    if (process.env.NODE_ENV === "development") {
      //skip version check on development build (ex: npm run dev not npm run build @localhost)
      return Promise.resolve();
    }
    // Timestamp to invalidate caches
    const timestamp = new Date().getTime();

    return axiosInstance
      .get("/restricted/version.json" + "?t=" + timestamp, {
        progress: false
      } as AxiosRequestConfigDef)
      .then((res: any) => {
        store.commit("versionCheckTimestamp", timestamp);
        const remoteHash = res.data.hash;
        const remoteVersion = res.data.version;
        if (remoteVersion) {
          store.commit("updateRemoteVersion", remoteVersion);
        }
        if (remoteHash) {
          store.commit("updateHashVersion", remoteHash);
        }
      })
      .catch(err => {
        store.commit("versionCheckTimestamp", timestamp);
        console.error(err, "Could not get version, ignore in localhost");
        return Promise.reject(err);
      });
  }

  /**
   * Version guard "beforeEnter" for pages that can trigger an app reload if the version is changed
   * will reload page with window location to force reload of vue app if needed
   *
   * @param to
   * @param from
   * @param next
   */
  versionGuard(to: Route, from: Route, next: any) {
    if (store.getters.reloadAppTab) {
      window.location.pathname = to.fullPath;
    } else {
      return next();
    }
  }
}
